import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const TermsAndCondition = () => {

   return (<>

      {/* <ComponenetHeader
           name={'Terms & Condition'}
        /> */}

      <section className="content_page text-left">
         <div className="container">
            <div className="row content_page_style justify-content-center">
               <div className="col-md-12">
                  <h2 className="mb-4">Terms and Conditions</h2>
                  <p><strong>DO NOT USE Mechanic Hunt WHILE DRIVING OR OPERATING ANY VEHICLE.</strong></p>

                  <p>
                     Please read these Terms and Conditions ("Terms") carefully before accessing or using the Mechanic Hunt website, mobile site, or mobile applications (the "Service"). The Service is operated by Mechanic Hunt ("we," "us," "our," or "the company"). By using the Service, you agree to comply with and be bound by these Terms, which apply to all users, visitors, and anyone accessing the platform.
                  </p>
                  <p>
                     If you do not agree with any part of these Terms, you must discontinue use of the Service. We may revise or update these Terms at any time without prior notice, and your continued use of the platform signifies acceptance of the modified Terms. Changes take effect immediately upon being posted.
                  </p>

                  <h3>Service Description</h3>
                  <p>
                     Mechanic Hunt provides online marketing and listing services for repair shops, towing providers, roadside assistance, and other vehicle-related service businesses across the United States. The Service includes access to an online directory of vendors ("Advertisers") through the Mechanic Hunt website and mobile applications. Users are responsible for providing necessary internet-enabled devices and covering associated data or connectivity costs.
                  </p>

                  <h3>User Accounts</h3>
                  <p>
                     Upon registration, users receive login credentials for their account and are responsible for maintaining the confidentiality of their password. All activity under your account is your responsibility. Any unauthorized use must be reported immediately. Accounts are personal and may not be sold, transferred, or used for commercial purposes without written authorization from Mechanic Hunt.
                  </p>

                  <h3>Vendor Information Disclaimer</h3>
                  <p>
                     Vendor details and product information displayed on the platform are provided either by the vendors themselves or gathered from publicly available sources. While Mechanic Hunt aims to present accurate information, we do not guarantee its reliability. Users assume full responsibility when relying on vendor-provided details.
                  </p>

                  <h4>Service Modifications and Interruptions</h4>
                  <p>
                     Mechanic Hunt reserves the right to change, suspend, or discontinue any part of the Service at any time without prior notification. We are not liable for interruptions or issues caused by circumstances beyond our control.
                  </p>

                  <h4>Privacy</h4>
                  <p>
                     Your use of the Service is governed by Mechanic Hunt’s Privacy Policy. Links to third-party platforms included on our website are governed by their own terms and privacy practices. We do not endorse or assume responsibility for external content or availability.
                  </p>

                  <h4>Prohibited Activities</h4>
                  <p>
                     Users must comply with these Terms when using the Service. Activities such as copying platform content, attempting to compete with Mechanic Hunt, misusing information, conducting fraudulent actions, or engaging in any harmful behavior are strictly prohibited. Violations may result in account suspension, legal action, or both.
                  </p>

                  <h4>User Information</h4>
                  <p>
                     By using the Service, you may provide personal information that may be shared with Advertisers to fulfill your service requests. By submitting your information, you consent to being contacted by Mechanic Hunt or its partners via SMS, email, phone, or other communication channels. You must provide accurate, current information and update it as necessary. Providing false or misleading information may result in penalties, denial of service, or legal consequences.
                  </p>

                  <h5>Intellectual Property</h5>
                  <p>
                     All content, trademarks, graphics, software, and other materials available on the platform are owned by Mechanic Hunt or licensed for use. They are protected by copyright and other intellectual property laws. Unauthorized reproduction, modification, distribution, or use of any content is strictly prohibited. Any third-party trademarks displayed belong to their respective owners.
                  </p>

                  <h5>Copyright Infringement Notification</h5>
                  <p>If you believe your copyrighted material has been used improperly on our platform, you may contact us at:</p>
                  <ul>
                     <li><strong>Phone:</strong> +1 (800) 805-7820</li>
                     <li><strong>Email:</strong> mechanichunt@gmail.com</li>
                  </ul>

                  <h5>Legal Compliance</h5>
                  <p>
                     Users must adhere to all applicable state, federal, and local laws while using the Service. Any actions that encourage illegal behavior are prohibited.
                  </p>

                  <h5>Disclaimer of Warranties</h5>
                  <p>
                     Mechanic Hunt provides the Service on an "as-is" and "as-available" basis. We make no warranties regarding the accuracy, reliability, or suitability of Advertiser information or Service performance. Mechanic Hunt is not responsible for any damages resulting from use or inability to use the platform.
                  </p>

                  <h5>Limitation of Liability</h5>
                  <p>
                     Mechanic Hunt is not liable for any direct, indirect, incidental, or consequential damages arising from your use of the Service. Certain jurisdictions may not allow limitations of liability, so some of these restrictions may not apply to specific users.
                  </p>

                  <h6>Indemnification</h6>
                  <p>
                     Users agree to defend and indemnify Mechanic Hunt, its affiliates, partners, and personnel against any claims, damages, or losses arising from misuse of the Service or violation of these Terms.
                  </p>

                  <h6>General Terms</h6>
                  <p>
                     These Terms are governed by the laws of Illinois. Any disputes will be resolved exclusively in the courts located in DuPage County, Illinois. All claims must be filed within one year of the event giving rise to the claim. If any part of these Terms is found unenforceable, the remaining provisions will continue in full effect.
                  </p>

                  <h6>Points System</h6>

                  <p className="mb-1"><strong>Earning Points</strong></p>
                  <ul>
                     <li>Users can earn coins by uploading qualifying service invoices such as truck repair bills or other eligible service-related documents.</li>
                     <li>Every 100 Coins earned equals $10 in rewards.</li>
                  </ul>

                  <p className="mb-1"><strong>Redeeming Points</strong></p>
                  <ul>
                     <li>Users may redeem their rewards once they accumulate a minimum of $100 (1,000 Coins).</li>
                     <li>Redeemed funds will be deposited into the user's selected payout method as supported by the platform.</li>
                  </ul>

                  <p className="mb-1"><strong>Minimum Balance Requirement</strong></p>
                  <ul>
                     <li>A minimum balance of $10 (100 Coins) must remain in the user's account at all times.</li>
                     <li>Redemption requests that reduce the balance below this requirement will not be processed.</li>
                  </ul>

                  <p className="mb-1"><strong>Fraud & Abuse</strong></p>
                  <ul>
                     <li>Any attempt to manipulate the points system, including uploading fake or altered invoices, will result in immediate account suspension and forfeiture of all earned coins.</li>
                  </ul>

                  <p className="mb-1"><strong>Modification of Terms</strong></p>
                  <ul>
                     <li>Mechanic Hunt may update, change, or discontinue the points system at any time without prior notice. Users should review this section regularly for updates.</li>
                  </ul>

                  <p className="mb-1"><strong>Disputes & Final Decision</strong></p>
                  <ul>
                     <li>In case of any dispute regarding coin accumulation or redemption, the decision made by the platform administration will be final and binding.</li>
                  </ul>

               </div>
            </div>
         </div>
      </section>
   </>
   );
};

export default TermsAndCondition;